<template>
  <a-form-field
    :errors="errors"
    :has-error="hasError"
    :help="help"
    :id="id"
    :label="label"
    label-type="p"
  >
    <ul
      slot-scope="slotProps"
      :aria-describedby="slotProps.describedby"
      :class="{ 'form-list--inline': inline }"
      class="form-list"
    >
      <slot/>
    </ul>
  </a-form-field>
</template>

<script>
import AFormField from '@/components/form/atoms/AFormField'

export default {
  name: 'CFormList',

  components: {
    AFormField
  },

  props: {
    errors: {
      type: Array
    },
    hasError: {
      type: Boolean
    },
    id: {
      type: String,
      required: true
    },
    inline: {
      type: Boolean
    },
    label: {
      type: String
    },
    help: {
      type: String
    }
  }
}
</script>

<style scoped>
.form-list {
  margin: 0;
  padding: 0;

  list-style: none;
}

.form-list--inline {
  display: flex;
  flex-wrap: wrap;
}
</style>

<style>
.form-list--inline > .form-list-item {
  margin-right: 20px;
}
</style>
